import * as React from "react";
import { Datagrid, FunctionField, ListContextProvider, ListToolbar, TextField, TopToolbar } from "react-admin";
import keyBy from "lodash/keyBy";
import ServiceableServiceLevelDetailComponent from "./ServiceableServiceLevelDetailComponent";
import { Grid, IconButton, Tooltip, Zoom, Box, Typography, makeStyles } from "@material-ui/core";
import { Pageview } from "@material-ui/icons";
import { ExcelExport } from "../../../Helper/ExportExcel";
import { ServiceableServiceLevelHeader, ServiceableServiceLevelName } from "./Excel";
import DownloadIcon from "@material-ui/icons/GetApp";
import { sortByCategory } from "../../../Helper/CategorySortHelper";

const useFooterStyles = makeStyles(theme => ({
  footerContainer: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: theme.spacing(2),
    backgroundColor: "#f5f5f5",
    borderTop: "2px solid #ddd",
    marginTop: theme.spacing(1),
    gap: theme.spacing(3),
  },
  totalItem: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  totalLabel: {
    fontWeight: 600,
    fontSize: "14px",
    color: "#666",
  },
  totalValue: {
    fontWeight: 700,
    fontSize: "16px",
    color: "#333",
  },
}));

const ServiceableServiceLevelGridComponent = ({ data }, props) => {
  // const [page, setPage] = React.useState(1);
  // const [perPage, setPerPage] = React.useState(5);
  const [isOpenPopup, setIsOpenPopup] = React.useState(false);
  const [detailData, setDetailData] = React.useState([] as any);
  const footerClasses = useFooterStyles();

  const GetTempData = () => {
    // Performanslı helper kullanarak sırala ve sonra sayfalama uygula
    const sortedData = sortByCategory(data, "category");
    return sortedData;
    // return sortedData.slice((page - 1) * perPage, perPage * page);
  };

  // Toplam değerleri hesapla
  const calculateTotals = () => {
    const tempData = GetTempData();
    const totalOnTime = tempData.reduce((sum: number, item: any) => sum + (Number(item.onTime) || 0), 0);
    const totalDelayed = tempData.reduce((sum: number, item: any) => sum + (Number(item.delayed) || 0), 0);

    return {
      totalOnTime,
      totalDelayed,
    };
  };

  // Footer component
  const TotalsFooter = () => {
    const totals = calculateTotals();

    return (
      <Box className={footerClasses.footerContainer}>
        <Box className={footerClasses.totalItem}>
          <Typography className={footerClasses.totalLabel}>Total OnTime:</Typography>
          <Typography className={footerClasses.totalValue}>{totals.totalOnTime}</Typography>
        </Box>
        <Box className={footerClasses.totalItem}>
          <Typography className={footerClasses.totalLabel}>Total Delayed:</Typography>
          <Typography className={footerClasses.totalValue}>{totals.totalDelayed}</Typography>
        </Box>
      </Box>
    );
  };

  const fieldsInClick = record => {
    setDetailData(record.cockpitServiceableServiceLevelDetail);
    setIsOpenPopup(true);
  };

  const ExportExcelButton = props => {
    return (
      <IconButton style={{ width: 40, color: "#C90C0F" }} onClick={ExportToExcel} disabled={data === 0}>
        <DownloadIcon />
      </IconButton>
    );
  };

  const handleAircraftUtilizationFilePopupClose = () => {
    setIsOpenPopup(false);
    setDetailData([]);
  };

  const DetailPopup = props => {
    return (
      <IconButton
        style={{ width: 40 }}
        onClick={() => {
          fieldsInClick(props?.record);
        }}
        disabled={props?.isDisabled}
      >
        <Tooltip TransitionComponent={Zoom} title="Details">
          <Pageview />
        </Tooltip>
      </IconButton>
    );
  };

  const ExportToExcel = () => {
    // Excel export için de helper kullan
    const sortedData = sortByCategory(data, "category");

    ExcelExport(
      ServiceableServiceLevelHeader,
      sortedData.map(v => [v.category, v.onTime, v.delayed]),
      ServiceableServiceLevelName
    );
  };

  const ListActions = props => (
    <TopToolbar>
      <ExportExcelButton />
    </TopToolbar>
  );

  return (
    <>
      <ListContextProvider
        value={{
          data: keyBy(GetTempData(), "id"),
          ids: GetTempData().map(({ id }) => id),
          currentSort: { field: "id", order: "DESC" },
        }}
      >
        <ListToolbar actions={<ListActions />} />
        <Datagrid {...props}>
          <FunctionField
            style={{ fontSize: 12 }}
            label="Status"
            render={(record: any) => (
              <DetailPopup record={record} isDisabled={record?.cockpitServiceableServiceLevelDetail == null} />
            )}
          />
          {/* <TextField source="contractName" label="Contract" /> */}
          <TextField source="category" label="Category" />
          <TextField source="onTime" label="OnTime" />
          <TextField source="delayed" label="Delayed" />
        </Datagrid>
        <TotalsFooter />
        {/* <Pagination
                    //@ts-ignore
                    page={page}
                    perPage={perPage}
                    setPage={setPage}
                    setPerPage={setPerPage}
                    total={data.length}
                /> */}
      </ListContextProvider>
      <Grid>
        {isOpenPopup && (
          <ServiceableServiceLevelDetailComponent
            open={isOpenPopup}
            data={detailData}
            handleClose={handleAircraftUtilizationFilePopupClose}
          />
        )}
      </Grid>
    </>
  );
};

export default ServiceableServiceLevelGridComponent;
